/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { constraint_scopes } from './constraint_scopes';
export type constraint_full = {
  id: string;
  name: string;
  version_id: number;
  army_id: number | null;
  army_organisation_id: number | null;
  include_child_selections: boolean;
  include_child_forces: boolean;
  percent_value: boolean;
  scope: constraint_scopes;
  shared: boolean;
  limit: constraint_full.limit;
  value: number;
  field: constraint_full.field;
};
export namespace constraint_full {
  export enum limit {
    MAX = 'Max',
    MIN = 'Min',
  }
  export enum field {
    SELECTIONS = 'Selections',
    POINTS = 'Points',
    MODELS = 'Models',
  }
}
